import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';

import services from 'api/services';
import { Button } from 'components/Button/RoundButton';
import { Container, Wrapper } from 'components/Layout/Layout';
import YesNoModal from 'components/Modals/yesNoModal';
import { isValidEmail } from 'functions/stringValidation';
import { Table, TableBody, TableHead, TableRow, TableHeading, TableData } from 'components/CMSRankList/styles';
import {
  SubjectInput,
  Header,
  GridContainer,
  Section,
  PreviewHeading,
  PreviewContainer,
  ErrorMessage,
  TextArea,
  TestEmailContainer,
  SubHeader,
  ButtonsContainer,
} from './styles';
const { CommunityEmailService } = services;

export default React.memo(() => {
  const [subject, setSubject] = useState(localStorage.getItem('fs-communityEmail-subject') ?? '');
  const [template, setTemplate] = useState(localStorage.getItem('fs-communityEmail-template') ?? '');
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, showErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [isTestEmail, setIsTestEmail] = useState('');
  const [sentEmails, setSentEmails] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      let emails = await CommunityEmailService.getCommunityEmails();
      setSentEmails(emails);
    };
    fetch();
  }, []);

  const renderTableHeading = () => (
    <TableRow isHeading>
      <TableHeading>Subject</TableHeading>
      <TableHeading>Date</TableHeading>
      <TableHeading>Sender</TableHeading>
    </TableRow>
  );

  const renderTableBody = () =>
    sentEmails.map((sentEmail) => (
      <TableRow
        key={sentEmail._id}
        isSelectedRow
        onClick={() => {
          setSubject(sentEmail.subject);
          localStorage.setItem('fs-communityEmail-subject', sentEmail.subject);
          setTemplate(sentEmail.template);
          localStorage.setItem('fs-communityEmail-template', sentEmail.template);
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }}
      >
        <TableData>{sentEmail.subject}</TableData>
        <TableData>{moment(sentEmail.createdAt).format('DD/MM/YYYY')}</TableData>
        <TableData>
          {sentEmail.userDetails.name} {sentEmail.testEmail && `(${sentEmail.testEmail})`}
        </TableData>
      </TableRow>
    ));

  return (
    <Wrapper padding="35px 0 0 0" minHeight="100vh">
      {showModal && (
        <YesNoModal
          modalInfo={{
            title: 'Confirmation',
            body: isTestEmail
              ? `Do you want to send the test email to ${email}?`
              : `Do you want to send the email to all members?`,
          }}
          confirm={async (isConfirmed) => {
            setShowModal(false);
            if (isConfirmed) {
              try {
                let params = { subject, template };
                if (isTestEmail) params.email = email;
                let sentEmail = await CommunityEmailService.sendCommunityEmail(params);
                setSentEmails([sentEmail, ...sentEmails]);
                toast.success('Email sent successfully');
              } catch (e) {
                toast.error(e.message || 'Error sending email');
              }
            }
          }}
        />
      )}
      <Container column>
        <Header>Community Email</Header>
        <GridContainer>
          <Section>
            <SubjectInput
              value={subject}
              placeholder="Subject*"
              onChange={(e) => {
                setSubject(e.target.value);
                localStorage.setItem('fs-communityEmail-subject', e.target.value);
              }}
            ></SubjectInput>
            <TextArea
              placeholder="Template*"
              value={template}
              onChange={(e) => {
                setTemplate(e.target.value);
                localStorage.setItem('fs-communityEmail-template', e.target.value);
              }}
            />
            {errorMessage && <ErrorMessage>Subject and Template are required</ErrorMessage>}
            <ButtonsContainer>
              <Button
                small
                primaryBlue
                primaryGreenBorder
                removeMargin
                margin="15px 0 0"
                onClick={() => {
                  if (!subject || !template) return showErrorMessage(true);
                  else showErrorMessage(false);
                  setIsTestEmail(false);
                  setShowModal(true);
                }}
              >
                Send to all members
              </Button>
              <Button
                small
                primaryBlue
                primaryGreenBorder
                removeMargin
                margin="15px 0 0"
                onClick={() => {
                  setSubject('');
                  localStorage.setItem('fs-communityEmail-subject', '');
                  setTemplate('');
                  localStorage.setItem('fs-communityEmail-template', '');
                }}
              >
                Clear
              </Button>
            </ButtonsContainer>
            <TestEmailContainer>
              <SubjectInput
                value={email}
                placeholder="Enter test email here"
                isEmailField
                onChange={(e) => setEmail(e.target.value)}
              ></SubjectInput>
              <Button
                small
                primaryBlue
                primaryGreenBorder
                removeMargin
                margin="15px 0 0"
                onClick={() => {
                  if (!isValidEmail(email)) return toast.error('Email is not valid');
                  else if (!subject || !template) return showErrorMessage(true);
                  setIsTestEmail(true);
                  setShowModal(true);
                }}
              >
                Test send
              </Button>
            </TestEmailContainer>
          </Section>
          <Section>
            <PreviewHeading>Preview</PreviewHeading>
            <PreviewContainer dangerouslySetInnerHTML={{ __html: template }} />
          </Section>
        </GridContainer>
        <SubHeader>Sent Emails</SubHeader>
        <Table>
          <TableHead>{renderTableHeading()}</TableHead>
          <TableBody>{renderTableBody()}</TableBody>
        </Table>
      </Container>
    </Wrapper>
  );
});
